// FIX: curriculum.js is now the SINGLE source of truth for free/locked status.
// Modules 01-03 = free. Modules 04-10 = premium.
// Home.jsx and Modules.jsx should read free status from HERE, not hardcode it.

const curriculum = {
  "01": {
    order: 1,
    title: "Mindset & Foundation",
    color: "#10b981",
    lessons: {
      "01": { title: "Why 90% of traders lose money",           duration: "8 min",  free: true  },
      "02": { title: "Trading vs investing vs gambling",         duration: "7 min",  free: true  },
      "03": { title: "How markets actually work",               duration: "9 min",  free: true  },
      "04": { title: "Types of markets",                        duration: "8 min",  free: true  },
      "05": { title: "Setting realistic expectations",           duration: "6 min",  free: true  },
    }
  },
  "02": {
    order: 2,
    title: "Reading Price & Charts",
    color: "#3b82f6",
    lessons: {
      "01": { title: "What is price action?",                            duration: "8 min", free: true },
      "02": { title: "Timeframes explained",                             duration: "7 min", free: true },
      "03": { title: "Bar charts vs line charts vs candlesticks",        duration: "6 min", free: true },
      "04": { title: "How to read a chart like a trader",               duration: "9 min", free: true },
      "05": { title: "Reading market trends — uptrend, downtrend, sideways", duration: "10 min", free: true },
    }
  },
  "03": {
    order: 3,
    title: "Candlestick Mastery",
    color: "#f97316",
    lessons: {
      "01": { title: "Anatomy of a candlestick",        duration: "8 min",  free: true },
      "02": { title: "What candles really show",         duration: "7 min",  free: true },
      "03": { title: "Single candle patterns",           duration: "12 min", free: true },
      "04": { title: "Two-candle patterns",              duration: "10 min", free: true },
      "05": { title: "Three-candle patterns",            duration: "10 min", free: true },
      "06": { title: "Context is everything",            duration: "8 min",  free: true },
      "07": { title: "Pattern recognition practice",     duration: "15 min", free: true },
      "08": { title: "Spinning Top & Marubozu — the two extremes", duration: "9 min", free: true },

    }
  },
  // ── PREMIUM from here down ────────────────────────────────────────────────
  "04": {
    order: 4,
    title: "Market Structure",
    color: "#eab308",
    lessons: {
      "01": { title: "Trends — uptrend, downtrend, sideways", duration: "9 min",  free: false },
      "02": { title: "Support & Resistance",                   duration: "11 min", free: false },
      "03": { title: "Higher highs, higher lows",              duration: "8 min",  free: false },
      "04": { title: "Break of structure",                     duration: "9 min",  free: false },
      "05": { title: "Key levels — zones not lines",           duration: "8 min",  free: false },
      "06": { title: "Fibonacci Retracements — the professional's tool", duration: "12 min", free: false },
    }
  },
  "05": {
    order: 5,
    title: "Chart Patterns",
    color: "#a855f7",
    lessons: {
      "01": { title: "Continuation patterns",    duration: "11 min", free: false },
      "02": { title: "Reversal patterns",         duration: "11 min", free: false },
      "03": { title: "Consolidation patterns",    duration: "9 min",  free: false },
      "04": { title: "Volume confirmation",       duration: "8 min",  free: false },
      "05": { title: "How to trade the pattern",  duration: "10 min", free: false },
    }
  },
  "06": {
    order: 6,
    title: "Technical Indicators",
    color: "#06b6d4",
    lessons: {
      "01": { title: "Why indicators lag",                    duration: "7 min",  free: false },
      "02": { title: "Moving averages",                        duration: "10 min", free: false },
      "03": { title: "RSI — Relative Strength Index",         duration: "10 min", free: false },
      "04": { title: "MACD",                                   duration: "10 min", free: false },
      "05": { title: "Bollinger Bands",                        duration: "9 min",  free: false },
      "06": { title: "Volume indicators",                      duration: "8 min",  free: false },
      "07": { title: "Combining indicators the right way",    duration: "10 min", free: false },
      "08": { title: "ATR — set smarter stops using volatility", duration: "10 min", free: false },

    }
  },
  "07": {
    order: 7,
    title: "Risk Management",
    color: "#ef4444",
    lessons: {
      "01": { title: "The 1% rule",                       duration: "8 min",  free: false },
      "02": { title: "Position sizing calculator",         duration: "9 min",  free: false },
      "03": { title: "Stop loss placement",               duration: "10 min", free: false },
      "04": { title: "Risk-to-reward ratio",              duration: "9 min",  free: false },
      "05": { title: "Drawdown and account management",   duration: "8 min",  free: false },
      "06": { title: "Portfolio risk",                    duration: "8 min",  free: false },
    }
  },
  "08": {
    order: 8,
    title: "Trading Strategies",
    color: "#8b5cf6",
    lessons: {
      "01": { title: "Strategy anatomy",               duration: "9 min",  free: false },
      "02": { title: "Trend following strategies",      duration: "11 min", free: false },
      "03": { title: "Reversal strategies",             duration: "10 min", free: false },
      "04": { title: "Breakout strategies",             duration: "10 min", free: false },
      "05": { title: "Multi-timeframe analysis",        duration: "11 min", free: false },
      "06": { title: "Building a trading plan",         duration: "12 min", free: false },
    }
  },
  "09": {
    order: 9,
    title: "Backtesting & Practice",
    color: "#22c55e",
    lessons: {
      "01": { title: "What is backtesting?",         duration: "8 min",  free: false },
      "02": { title: "How to backtest manually",      duration: "10 min", free: false },
      "03": { title: "Paper trading",                 duration: "9 min",  free: false },
      "04": { title: "Tracking your trades",          duration: "8 min",  free: false },
      "05": { title: "Measuring your edge",           duration: "9 min",  free: false },
    }
  },
  "10": {
    order: 10,
    title: "Trading Psychology",
    color: "#ec4899",
    lessons: {
      "01": { title: "Fear and greed in trading",          duration: "9 min", free: false },
      "02": { title: "Revenge trading",                     duration: "8 min", free: false },
      "03": { title: "FOMO and overtrading",               duration: "8 min", free: false },
      "04": { title: "Building discipline",                 duration: "9 min", free: false },
      "05": { title: "The growth mindset for traders",     duration: "8 min", free: false },
      "06": { title: "Thinking in probabilities — the Mark Douglas concept", duration: "11 min", free: false },

    }
  },
};

export default curriculum;